import React from "react";
import clsx from "clsx";
import './style.css';
import {Typography} from "../Typography";

export const BaseInput = ({
  onChange,
  onKeyDown = (e) => null,
  placeholder='請輸入',
  value,
  isDisabled =false,
  isRequired = true,
  type = 'text',
  label = '',
}) => (
  <div className="flex flex-1 flex-col gap-2">
    {!!label && (
      <Typography variant="bodyBold">
        {label}
      </Typography>
    )}
    <input
      className={clsx("input-box", {"input-box-disabled": isDisabled})}
      placeholder={placeholder}
      type={type}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      disabled={isDisabled}
      required={isRequired}
    />
  </div>
)
